module.exports = __webpack_public_path__ + "img/no-insights-activity.79b28da1.png";